import { Spinner, SpinnerProps } from '@chakra-ui/react'
import React from 'react'

import { FullScreenLoaderProps, FullscreenWrapper } from './FullscreenWrapper'

export const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
  loading,
  opacity = 0.2,
  ...loaderProps
}) => (
  <FullscreenWrapper data-testid="loader" loading={loading} opacity={opacity}>
    <Loader {...loaderProps} size="xl" />
  </FullscreenWrapper>
)

export const Loader = (props: SpinnerProps) => (
  <Spinner
    color="deepPurple"
    emptyColor="neutral.10"
    size="md"
    speed="1s"
    thickness="3px"
    {...props}
  />
)
